// extracted by mini-css-extract-plugin
export default {"main":"ProgressBar_main__iYA4w","bar":"ProgressBar_bar__8ZQZR","mainBar":"ProgressBar_mainBar__C1YOo","subBar":"ProgressBar_subBar__3ZgOR","labels":"ProgressBar_labels__+XJob"};